import { render, staticRenderFns } from "./ImgViewframe.vue?vue&type=template&id=efcba9e0&"
import script from "./ImgViewframe.vue?vue&type=script&lang=js&"
export * from "./ImgViewframe.vue?vue&type=script&lang=js&"
import style0 from "./ImgViewframe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efcba9e0')) {
      api.createRecord('efcba9e0', component.options)
    } else {
      api.reload('efcba9e0', component.options)
    }
    module.hot.accept("./ImgViewframe.vue?vue&type=template&id=efcba9e0&", function () {
      api.rerender('efcba9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/imgViewframe/components/ImgViewframe.vue"
export default component.exports